var map = {
	"./beach.png": 5065,
	"./bike.png": 6183,
	"./fish.png": 8897,
	"./heron.png": 7525,
	"./lantern.png": 2901,
	"./logo.png": 6949,
	"./map.png": 3808,
	"./oak.png": 424,
	"./person-icon.png": 9427,
	"./poi.png": 693,
	"./selfie.png": 4949,
	"./solis.png": 7664,
	"./wander-logo.png": 9043,
	"./wellen-logo-icon.png": 4005,
	"./wellen-logo-label.png": 5208,
	"./wellen-logo.png": 6750,
	"./wildlife.png": 3723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;